(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_evervoice-delivery-timeline"] && !Shopify.designMode) return;
  try {
    (() => {
    const dayFormatter = new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric'
    });

    const addBusinessDays = (startDate, numberOfDays) => {
      const date = new Date(startDate);
      let daysAdded = 0;

      while (daysAdded < numberOfDays) {
        date.setDate(date.getDate() + 1);

        if (date.getDay() !== 0 && date.getDay() !== 6) {
          daysAdded += 1;
        }
      }

      return date;
    };

    const formatDateRange = (startDate, endDate) => {
      if (
        startDate.getFullYear() === endDate.getFullYear() &&
        startDate.getMonth() === endDate.getMonth()
      ) {
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(startDate);
        return `${month} ${startDate.getDate()}–${endDate.getDate()}`;
      }

      return `${dayFormatter.format(startDate)}–${dayFormatter.format(endDate)}`;
    };

    const toDateTime = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const updateTimeline = (timeline) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const dates = {
        order: {
          label: `${timeline.dataset.todayLabel}, ${dayFormatter.format(today)}`,
          start: today,
          end: today
        },
        processing: {
          label: formatDateRange(addBusinessDays(today, 1), addBusinessDays(today, 2)),
          start: addBusinessDays(today, 1),
          end: addBusinessDays(today, 2)
        },
        delivery: {
          label: dayFormatter.format(addBusinessDays(today, 8)),
          start: addBusinessDays(today, 8),
          end: addBusinessDays(today, 8)
        }
      };

      timeline.querySelectorAll('[data-evervoice-date]').forEach((dateElement) => {
        const dateValue = dates[dateElement.dataset.evervoiceDate];

        if (!dateValue) return;

        dateElement.textContent = dateValue.label;
        dateElement.setAttribute('datetime', toDateTime(dateValue.start));
        dateElement.setAttribute(
          'aria-label',
          dateValue.start.getTime() === dateValue.end.getTime()
            ? dateValue.label
            : `${dayFormatter.format(dateValue.start)} ${timeline.dataset.rangeLabel} ${dayFormatter.format(dateValue.end)}`
        );
      });
    };

    const updateAllTimelines = () => {
      document.querySelectorAll('[data-evervoice-delivery]').forEach(updateTimeline);
    };

    updateAllTimelines();
    document.addEventListener('shopify:section:load', updateAllTimelines);
    window.setInterval(updateAllTimelines, 60000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["evervoice-pdp-review-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('evervoice-pdp-review-slider')) {
    customElements.define('evervoice-pdp-review-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.move(-1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.move(1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index)));
        this.track?.addEventListener('scroll', () => this.syncFromScroll(), { passive: true });
        this.update();
      }

      move(direction) {
        if (!this.slides.length) return;
        this.go((this.index + direction + this.slides.length) % this.slides.length);
      }

      go(index) {
        if (!this.track || !this.slides[index]) return;
        this.index = index;
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: 'smooth' });
        this.update();
      }

      syncFromScroll() {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => {
          if (!this.track || !this.slides.length) return;
          const width = this.track.clientWidth || 1;
          this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
          this.update();
        }, 80);
      }

      update() {
        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
